import { inject } from '@angular/core';

import { APP_STORE } from '@core/stores/app.store';

export const PROJECT_CAN_ACTIVATE_GUARD = (): boolean => hasProjectId();

export const PROJECT_CAN_MATCH_GUARD = (): boolean => hasProjectId();

const hasProjectId = (): boolean => {
  const appStore = inject(APP_STORE);

  return !!appStore.selectedProjectId();
};
